import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { QuestionHttpModel } from '@examdojo/models/question';
import { ReferenceQuestionStoreModel } from '@examdojo/reference-question';
import { rethrowError } from '@examdojo/rxjs';
import { Observable } from 'rxjs';
import { QuestionType } from '../review-item/review-item.model';
import { ReviewItemService } from '../review-item/review-item.service';
import { QuestionHistoryEntry } from './generic-question-history.model';

@Injectable({
  providedIn: 'root',
})
export class GenericQuestionHistoryService {
  constructor(
    private readonly reviewItemService: ReviewItemService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  getQuestionHistory(questionId: number, questionType: QuestionType): Observable<QuestionHistoryEntry[]> {
    switch (questionType) {
      case QuestionType.Reference:
        return this.reviewItemService
          .getReferenceQuestionComprehensiveHistory(questionId as ReferenceQuestionStoreModel['id'])
          .pipe(
            this.errorHandlerService.catchError(
              '[GenericQuestionHistoryService]: Fetching reference question history failed',
              rethrowError(),
              {
                toast: (err) => ({
                  title: 'Failed to load reference question history',
                  description: (err as Error)?.message,
                }),
                context: { questionId, questionType },
              },
            ),
          );

      case QuestionType.Derivative:
        return this.reviewItemService
          .getDerivativeQuestionComprehensiveHistory(questionId as QuestionHttpModel['id'])
          .pipe(
            this.errorHandlerService.catchError(
              '[GenericQuestionHistoryService]: Fetching derivative question history failed',
              rethrowError(),
              {
                toast: (err) => ({
                  title: 'Failed to load derivative question history',
                  description: (err as Error)?.message,
                }),
                context: { questionId, questionType },
              },
            ),
          );
    }
  }
}
